// extracted by mini-css-extract-plugin
module.exports =  {"dropdown":"b7635b5199--dropdown--DX7TI"};